import styled from 'styled-components';

export const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
  width: 100%;
  padding: 8px 0;
`;

export const InstructionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InstructionsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TextDescriptionContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

